import React, { useEffect, useState } from "react";
import { API_empleos } from "../../config/apiConfig";
import { Link } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import "../../pages/user/css/Empleo.css";
import { useAuth } from "../../context/AuthContext";

const EmpleosDestacados = ({ categoria }) => {
  const { token } = useAuth();
  const [ofertas, setOfertas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const obtenerOfertas = async () => {
      try {
        const response = await fetch(`${API_empleos}`, {
          headers: {
            "x-auth-token": token,
          },
        });
        const data = await response.json();

        let filtradas = data;

        if (categoria === "destacadas") {
          filtradas = data.filter((oferta) => oferta.isFeatured);
        } else if (categoria === "isla") {
          filtradas = data.filter((oferta) =>
            oferta.location.toLowerCase().includes("isla cristina")
          );
        }

        setOfertas(filtradas);
      } catch (error) {
        console.error("Error al obtener ofertas:", error);
        setOfertas([]);
      } finally {
        setLoading(false);
      }
    };

    obtenerOfertas();
  }, [categoria]);

  if (loading) return <p>Cargando ofertas...</p>;
  if (ofertas.length === 0)
    return (
      <p className="mt-30">
        Lo sentimos, pero en este momento no tenemos ofertas con estas
        características.
      </p>
    );

  // Fecha en formato DD/MM/AAAA
  const formatearFecha = (fecha) => {
    const date = new Date(fecha);
    return date.toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="carrusel wrap w-100">
      {ofertas.map((oferta, index) => (
        <div key={index} className="recurso">
          <h2 className="mayusculas">{oferta.title}</h2>
          <p>{oferta.company}</p>
          <p className="fecha">
            Publicado el: {formatearFecha(oferta.publicationDate)}
          </p>
          <p className="align-center gap-5 ubicacion">
            <FaLocationDot />
            {oferta.location}
          </p>
          <Link
            className="verde"
            to={`/empleo/${oferta._id}`}
            aria-label="Más información sobre la oferta de empleo"
          >
            Más información
          </Link>
        </div>
      ))}
    </div>
  );
};

export default EmpleosDestacados;
